import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function RatingProof() {
  const faces = testimonials.slice(0, 5);
  return <div className="flex items-center gap-3" data-id="element-250" data-mp="3bqkalz9t0j9y">
      <div className="flex -space-x-2.5" data-id="element-251" data-mp="3bpsjb0n8p7ph">
        {faces.map(t => <img key={t.author} src={t.avatar} alt="" width={36} height={36} className="h-9 w-9 rounded-full object-cover object-[50%_28%] ring-2 ring-plum-deep" data-id="element-252" data-mp="3ghk9vb6ebdfm" />)}
      </div>
      <div className="leading-tight" data-id="element-253" data-mp="3pjtke11nz6t0">
        <div className="flex items-center gap-0.5" role="img" aria-label="Rated 4.9 out of 5" data-id="element-254" data-mp="3ugscyf5oj5p3">
          {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-255" data-mp="39zbda6z54k1" />)}
        </div>
        <p className="mt-1 whitespace-nowrap text-[13px] text-white/75" data-id="element-256" data-mp="205dm1v0xn07r">
          <span className="font-semibold text-white" data-id="element-257" data-mp="252ds45xs82yv">4.9/5</span> from 300+ Game Masters
        </p>
      </div>
    </div>;
}